import {
  nostoCollectionQuery,
  nostoSearchQuery,
  renderNostoCollectionResults,
  showProductCount,
  renderSort,
  renderNostoCollectionFacets,
  updateQueryWithFilterAndSort,
  nostoRecordSearch,
  nostoTrackResultClicks,
  paginationUI
} from "@theme/nosto-functions";

(() => {

  const pageLimit = nostoProductsPerPage;
  const url = new URL(window.location);

  let SEARCH = false;
  let SEARCH_QUERY = '';
  let SEARCH_SESSION_PARAMS = null;

  // bump the version when the nosto query fields change so stale cached results aren't used
  const COLLECTION_STORAGE_KEY = 'nosto-ecom-collection-v2-' + (typeof collectionId != 'undefined' ? collectionId : '');

  // hits currently shown in the grid, used to record product clicks
  let CURRENT_HITS = [];
  nostoTrackResultClicks('#product-grid a[href*="/products/"]', () => SEARCH ? 'serp' : 'category', () => CURRENT_HITS);

  if (url.searchParams.get('q')) {
    SEARCH_QUERY = url.searchParams.get('q');
    SEARCH = true;
  }

  // collections render shopify's products first and nosto reorders them only if it answers within nostoTimeout,
  // otherwise shopify's order, filters, sort and load more are kept
  const NOSTO_TIMEOUT = typeof nostoTimeout != 'undefined' ? nostoTimeout : Infinity;
  const NOSTO_START = performance.now();
  let NOSTO_APPLIED = SEARCH;

  // shopify's cards by product id, so only the products nosto adds to the page are fetched
  const SHOPIFY_CARDS = new Map(
    [...document.querySelectorAll('#product-grid main-product[id^="product-card-"]')]
      .map(card => [card.id.replace('product-card-', ''), card.parentElement.innerHTML])
  );

  // in-grid promo tiles, put back at the same position after nosto reorders the grid
  const PROMOS = [...(document.getElementById('product-grid')?.children || [])]
    .map((el, index) => ({ el, index }))
    .filter(({ el }) => !el.querySelector('main-product'));


  if (SEARCH) {
    // hide product count
    document.getElementById('products-count').style.display = 'none';

    let interval,
      counter = 0,
      duration = 100,
      limit = 80;
    interval = setInterval(() => {
      if (typeof nostojs != 'undefined') {
        //console.log('nostojs found')
        //console.log(counter)

        nostojs(api => {
          // organic search: only when the query was submitted from the search input (flag set in -predictive-search.js),
          // and it must be recorded before the search request is sent
          let organicQuery = null;
          try {
            organicQuery = sessionStorage.getItem('nosto-search-submit');
            sessionStorage.removeItem('nosto-search-submit');
          } catch (e) { }
          if (organicQuery == SEARCH_QUERY) {
            api.recordSearchSubmit(SEARCH_QUERY);
          }

          api.getSearchSessionParams()
            .then(response => {
              //let searchSessionParams = response;
              SEARCH_SESSION_PARAMS = response;
              //getNostoSearchResults(params.q, searchSessionParams);
              getNostoCollectionResults();
            });
        })

        clearInterval(interval);
      } else if (counter === limit) {
        clearInterval(interval);
      }
      counter++;
    }, duration);

  } else if (!/[?&]filter\./.test(window.location.search)) {
    // shopify filter params (filter.v.*) mean the list is already filtered by shopify, so it's kept as is
    getNostoCollectionResults();
  }


  function getNostoCollectionResults(pagination = false) {

    let query = '';
    let variables = {}

    if (SEARCH) {
      query = updateQueryWithFilterAndSort(nostoSearchQuery());
      variables = {
        query: SEARCH_QUERY,
        sessionParams: SEARCH_SESSION_PARAMS
      };
    } else {
      query = updateQueryWithFilterAndSort(nostoCollectionQuery());
      variables = {
        categoryId: collectionId,
        //currencyCode: "EUR",
      }

    }

    const url = new URL(window.location);
    if (url.searchParams.size == 0) {
      const sessionResult = sessionStorage.getItem(COLLECTION_STORAGE_KEY)
      if (sessionResult) {
        const result = JSON.parse(sessionResult);

        console.log('use nosto session storage')

        showResult(result, pagination);

        return;

      }
    }


    fetch('https://search.nosto.com/v1/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: query,
        variables: variables,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log('nosto result')
        console.log(result)

        // store unfiltered results in session storage, also when nosto was too late so the next visit is instant
        if (!SEARCH && url.searchParams.size == 0 && result.data?.search) {
          sessionStorage.setItem(COLLECTION_STORAGE_KEY, JSON.stringify(result))
          console.log('result saved in session storage')
        }

        showResult(result, pagination);


      })
      // on a collection shopify's products stay on the page when nosto fails
      .catch((error) => console.error('nosto', error))
  }

  function showResult(result, pagination) {
    if (!NOSTO_APPLIED) {
      const inTime = performance.now() - NOSTO_START <= NOSTO_TIMEOUT;
      if (!inTime || !result.data?.search?.products?.hits?.length) {
        return;
      }

      // nosto takes over the grid, its own load more replaces shopify's
      NOSTO_APPLIED = true;
      document.querySelectorAll('#product-grid-container load-more').forEach(el => el.remove());
    }

    render(result, pagination);

    // begin analytics
    // load more re-requests the same 250 results, so only new searches, filters and sorts are recorded
    if (!pagination) {
      recordSearch(result);
    }
  }

  function recordSearch(result) {
    if (!result.data || !result.data.search) {
      return;
    }

    if (SEARCH) {
      nostoRecordSearch(
        'serp',
        { query: SEARCH_QUERY, products: { size: 250, from: 0 } },
        result.data.search
      );
    } else {
      nostoRecordSearch(
        'category',
        { products: { categoryId: collectionId, size: 250, from: 0 } },
        result.data.search
      );
    }
  }

  function render(result, pagination) {
    const url = new URL(window.location);

    let page = 1;
    if (url.searchParams.has('page')) {
      page = Number(url.searchParams.get('page'));
    }

    let hits = result.data.search.products.hits;
    CURRENT_HITS = hits;
    //let hits = result.data.search.products.hits.filter(hit => hit.tags1.some(tag => tag.includes('mvp.')) == false);
    //let rejectedHits = result.data.search.products.hits.filter(hit => hit.tags1.some(tag => tag.includes('mvp.')) == true);

    //console.log('rejectedHits', rejectedHits)
    //console.log('hits', hits)
    

    // render results - product cards
    renderNostoCollectionResults(
      hits,
      SEARCH ? 'serp' : 'category',
      page,
      pagination,
      pageLimit,
      () => { paginationUI(page, hits.length, pageLimit, () => { getNostoCollectionResults(true) }) },
      SHOPIFY_CARDS
    );

    // promo tiles only show on the unfiltered grid, like on shopify's list
    if (!pagination && !url.search.includes('Filter.')) {
      const grid = document.getElementById('product-grid');
      PROMOS.forEach(({ el, index }) => grid.insertBefore(el, grid.children[index] || null));
    }

    // set product count
    showProductCount(hits.length);

    // render facets
    renderNostoCollectionFacets(result.data.search.products.facets, () => { getNostoCollectionResults() });

    // render sort
    setTimeout(() => {
      renderSort(() => { getNostoCollectionResults() });
    }, 1000)

  }

})();
